module.exports = __webpack_public_path__ + "img/SafewaterLogo.76aa7b98.svg";